<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <!--培训项目-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">报考专业</label>
                            <div class="col-sm-9">
								<BootstrapCombobox :data="xmList" @change="getKcList" text-field="mc" value-field="id" v-model="query.xmId" placeholder="-报考专业筛选-" :formatOption="(item)=>(item.xmbh+'-'+item.mc)"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>

                    <!--课程-->
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">课程</label>
                            <div class="col-sm-9">
                                <BootstrapCombobox :data="kcList" value-field="id" text-field="kcmc" v-model="query.kcId" :format-option="showOption"></BootstrapCombobox>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-sm-offset-6">
                        <div class="pull-right">
                            <button @click="search()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-search" aria-hidden="true"></i>查询</button>
                            <button   @click="addkt()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-plus" aria-hidden="true"></i>新增直播</button>
                            <button   @click="dc()" type="button" class="btn btn-primary btn-sm" style="margin-right:3px"><i class="fa fa-download" aria-hidden="true"></i>导出</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		<ZbXmBind ref="ZbXmBind"></ZbXmBind>
    </div>
</template>
<script>

    /**
     * 直播管理-直播列表
     */
    import tableMixin from '@/mixins/table.js';
    import ZbXmBind from './ZbXmBind.vue';//直播设置

    export default {
        mixins: [tableMixin],
        name:"ZhiboList",
        components :{
			ZbXmBind
        },
        data:function(){
            return {
                xmList:[],
                kcList:[],
                query:{
                    xmId:'',
                    kcId:''
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
                    {
                        field: 'kcdm',
                        title: '课程代码'
                    },
					{
					    field: 'kcmc',
					    title: '课程名称'
					},
                    {
                        field: 'pxzt',
                        title: '关联报考专业'
                    },
                    {
                        field: 'kssj',
                        title: '开始时间'
                    },
                    {
                        field: 'jssj',
                        title: '结束时间'
                    },
                    {
                        field: 'chapterlessoncount',
                        title: '课时统计'
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template: '<div class="operation_column">' +
                                    '<a @click="classDetails(row)">详情</a> | ' +
                                    '<a @click="edit(row)">编辑</a> | ' +
                                    '<a @click="goset(row)">设置</a></div>'
                                     ,
                                data: { row },
                                methods: {
                                    classDetails: this.classDetails,
                                    edit: this.edit,
                                    goset:this.goset
                                }
                            })
                        }
                    }
                ]
            }
        },
		 mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
			this.load();
		 },
		 beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
		 },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'自学考试'},{name:'日常练习管理'},{name:'直播管理'}]);
            this.getXmList();
            this.getKcList();
        },
        methods: {
            goset:function(row){
				this.$refs.ZbXmBind.open({ kczbid:row.kczbid});
            },
            // 导出
            dc:function(){//文件导出下载 标准写法
            	if(!this.query.xmId){
            		this.$error('请选择一个项目');
            		return;
            	}
            	if(!this.query.kcId){
            		this.$error('请选择一个课程');
            		return;
            	}
                window.open('/htgl/biz/zypx/zb/addressExport?xmId=' + this.query.xmId + "&kcId=" + this.query.kcId);
            },

            //新增直播
            addkt:function(){
                this.$router.push({name:'ZhiboAdd'});
            },
            //编辑直播
            edit:function(row){
                this.$router.push({name:'ZhiboEdit',query:{id:row.kczbid}});
            },
            // 课时详情
            classDetails:function(row){
                this.$router.push({name:'ZhiboDetailList',query:{kczbId:row.kczbid}});
            },
            //培训项目
            getXmList:function(){
                this.$http.post('/htgl/biz/zypx/zb/hqpc').then(res=>{
                    if(res.data){
                        this.xmList = res.data || [];
                    }
                });
            },
            //课程
            getKcList:function(){
                this.query.kcId = '';
                this.$http.post('/htgl/biz/zypx/zb/hqkc',{xmId:this.query.xmId}).then(res=>{
                    if(res.data){
                        this.kcList = res.data || [];
                    }
                });
            },
            //拼接课程代码/名称
            showOption:function(row){
                return row.kcdm+'-'+row.kcmc;
            },
            search:function(){
              //将数据表格的页码以及每一页展示的数据重置为1，10
              let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
              this.$router.push({name:this.$route.name,query:query});
            },
            //返回表格数据
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/biz/zypx/zb/cx',this.query).then(res=>{
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
            pageChange:function(pageNumber, pageSize){
                let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
                this.$router.push({name:this.$route.name,query:query});
            }
        }

    }
</script>
<style scoped>

</style>
